// extracted by mini-css-extract-plugin
module.exports = {"cloud_fail":"FJCloudFailButton_cloud_fail___oRXf","fail_icon":"FJCloudFailButton_fail_icon__3nHty","fail_desc":"FJCloudFailButton_fail_desc__J0Z18"};